module.exports = __webpack_public_path__ + "img/featuregraphic.790bde75.png";